<!-- <object [data]="url | safe" type="application/pdf">
    <div>No hay un visor de PDF instalado</div>
</object> -->
<div class="flex flex-column gap-3  h-full">
    <div class="flex justify-content-center">
        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" (click)="close()"></button>

    </div>
    <div class="flex  h-full">
        <iframe [src]="url" style="height: 99%;width: 100%;" frameborder="0" allowfullscreen sandbox="allow-scripts allow-same-origin" *ngIf="!loading"></iframe>

    </div>

</div>
